package com.bikompanion.ui.models

/**
 * What the locate-me FAB is currently doing with the camera.
 *
 * The three states are a cycle, one tap apart, because centring and heading-follow answer
 * different questions — "where am I on this map" and "which way am I pointing" — and a rider
 * reading station names does not want the map spinning under them for the first of those.
 * Panning, zooming or rotating the map by hand drops back to [Off]: the camera is then showing
 * ground the user chose, and a fix arriving afterwards must not drag it away.
 */
enum class LocateMode {
    /** The camera moves on its own only when the user asks. */
    Off,

    /** The camera is centred on the last fix; north stays up. */
    Centered,

    /** The camera follows the fix and turns to face the direction the rider is heading. */
    FollowingHeading,
}
